class BrandShowcase extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.brand-showcase');
    this.track = this.querySelector('[data-brand-track]');
    this.previousButton = this.section?.querySelector('[data-brand-previous]');
    this.nextButton = this.section?.querySelector('[data-brand-next]');
    if (!this.track) return;

    this.previousButton?.addEventListener('click', () => this.move(-1));
    this.nextButton?.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
    this.resizeObserver = new ResizeObserver(() => this.updateButtons());
    this.resizeObserver.observe(this.track);
    this.updateButtons();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
  }

  move(direction) {
    const card = this.track.querySelector('.brand-card');
    if (!card) return;
    const gap = Number.parseFloat(getComputedStyle(this.track).columnGap || 0);
    this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  }

  requestUpdate() {
    if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
    this.updateFrame = requestAnimationFrame(() => this.updateButtons());
  }

  updateButtons() {
    const end = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 2;
    if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= end - 2;
  }
}

if (!customElements.get('brand-slider')) customElements.define('brand-slider', BrandShowcase);
